var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transactions',{attrs:{"action":"addCredit","user":_vm.user,"event":_vm.event,"withOutActions":true,"titleCols":_vm.titleCols}})
}
var staticRenderFns = []

export { render, staticRenderFns }